import type { Profile, ProgressRecord } from "../lib/types";
import { profileById } from "../lib/lookups";
import type { BoardStore } from "../stores/board";

function boardStore(): BoardStore {
  return (window as unknown as { Alpine: { store(name: string): BoardStore } }).Alpine.store("board");
}

const EMPTY_PROGRESS: ProgressRecord = {
  program: "",
  completed: 0,
  total: 0,
  upcoming: "",
  upcomingDate: "",
  blockers: [],
  recommendation: "",
  recentGrades: [],
  flightHours: { dual: 0, solo: 0, total: 0 },
};

const FALLBACK_USER: Profile = {
  id: "",
  name: "—",
  role: "Student",
  initials: "—",
  color: "#999",
};

export function progressAlpine() {
  return {
    init() {
      const board = boardStore();
      const students = board.lookups.profiles.filter((p) => p.role === "Student");
      if (board.role === "Student" && students[0]) {
        board.selectedStudentId = students[0].id;
      } else if (!board.lookups.progress[board.selectedStudentId] && students[0]) {
        board.selectedStudentId = students[0].id;
      }
    },
    get studentList(): Profile[] {
      const board = boardStore();
      const all = board.lookups.profiles.filter((p) => p.role === "Student");
      return board.role === "Student" ? all.filter((u) => u.id === board.selectedStudentId) : all;
    },
    get selectedUser(): Profile {
      const board = boardStore();
      return profileById(board.lookups.profiles, board.selectedStudentId) ?? FALLBACK_USER;
    },
    get selectedProgress(): ProgressRecord {
      const board = boardStore();
      return board.lookups.progress[board.selectedStudentId] ?? EMPTY_PROGRESS;
    },
    get selectedPct(): number {
      const p = this.selectedProgress;
      return p.total ? Math.round((p.completed / p.total) * 100) : 0;
    },
    progressFor(id: string): ProgressRecord {
      return boardStore().lookups.progress[id] ?? EMPTY_PROGRESS;
    },
    pct(id: string): number {
      const p = boardStore().lookups.progress[id];
      return p && p.total ? Math.round((p.completed / p.total) * 100) : 0;
    },
  };
}
